import sticky_footer_cta_init from './sticky_footer_cta/init';

export default function footer_init() {
    
    sticky_footer_cta_init();
    scroll_to_top_btn_init();

    document.addEventListener('after_main_init', ()=>{
        close_footer_dropdowns();
    })
}

function scroll_to_top_btn_init(){
    const buttons = document.querySelectorAll('.scroll_to_top_btn, .scroll_to_top_btn_mobile');
    if( !buttons.length ) return;

    buttons.forEach(btn => {
        btn.addEventListener('click', ()=> {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
            console.log('bkt back to top');
        });
    });
}

function close_footer_dropdowns(){
    if( window.innerWidth > 768 ) return;
    document.querySelectorAll('.elementor-location-footer .ff_toggle_height_trigger.open').forEach(dropdown=>{
        dropdown.click();
    })
}